import { CompleteRegistrationRequest, CompleteRegistrationResponse } from '../completeregistration';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';

export async function completeRegistration(
    request: CompleteRegistrationRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<CompleteRegistrationResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const encodedRequest = CompleteRegistrationRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = "https://nh4b502uqb.execute-api.us-west-2.amazonaws.com/authservice/completeregistration";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): CompleteRegistrationResponse => {
        return CompleteRegistrationResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}